import { jsx as e } from "react/jsx-runtime";
import { PanelLeft as i } from "lucide-react";
import { cn as n } from "../../lib/utils.js";
import { useInsetSidebar as a } from "../hooks/use-inset-sidebar.js";
function l({
  className: t,
  "data-testid": r
}) {
  const { toggleSidebar: o } = a();
  return /* @__PURE__ */ e(
    "button",
    {
      onClick: o,
      className: n(
        "inline-flex items-center justify-center rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors",
        t
      ),
      "aria-label": "Toggle sidebar",
      "data-testid": r,
      children: /* @__PURE__ */ e(i, { className: "size-4", "aria-hidden": "true" })
    }
  );
}
export {
  l as InsetSidebarTrigger
};
